<template>
<div class="variant-select-wrap">
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected has-text-black" :class="{ open: open }" @click="open = !open">
      <span :class="'has-text-dark is-size-14 ' + (dropDownSelected ? 'is-flex justify-content-between' : '')" v-html="selected"></span> <i :class="open ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" aria-hidden="true"></i>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="selectThis(option)"
        :class="!option.available ? 'unavailable optionitem' : 'optionitem'"
      >
        <div class="is-flex justify-content-between">
          <p class="is-size-16px">{{ option.size ? option.size : '-n/a-' }}</p>
          <p v-if="isOnSale(option) && option.available" class="is-size-14 on-sale-variant has-text-weight-semibold"><span>{{ salePercentage(option) }}</span></p>
          <p :class="!option.available ? 'outofstock has-text-danger is-size-16px has-text-weight-semibold': ' is-size-22px has-text-weight-semibold'">{{ option.available && (option.no_of_units > option.inventory_threshold) ? '$'+ variantPrice(option) : 'Out of stock' }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    placeholdertext:{
      type: String,
      required: false,
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    callback: {
      type: Function,
      required: true,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      dropDownSelected: false,
      selected: this.placeholdertext,
      open: false,
    };
  },
  mounted() {
    // this.$emit("input", this.selected);
  },
  methods: {
    selectThis(option) {
      this.dropDownSelected = true;
      this.selected = option.size ? option.size + ' <span class="is-size-22px has-text-weight-semibold has-text-dark"> $' + this.variantPrice(option) + '</span>' : '-n/a-';
      this.open = false;
      this.callback(option)
      //this.$emit('input',option);
    },
    
    variantPrice(option) {
      if(option.sale_price && (option.sale_price < option.price)){
        return option.sale_price.toFixed(2);
      }
      return option.price.toFixed(2);
    },

    isOnSale(option) {
      if(option.sale_price && (option.sale_price < option.price)){
        return true
      }
      return false;
    },

    salePercentage(option) {
      let salePercentData = ((option.price-option.sale_price) / option.price)*100;
      return  ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% OFF';
    },
  },
};
</script>
<style scoped>

.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 40px;
  line-height: 40px
}

.custom-select .selected {
  border-radius: 4px;
  border: 2px solid #cfcfcf;
  color: #333;
  padding-left: 10px;
  padding-right: 35px;
  cursor: pointer;
  user-select: none;
}

.custom-select .selected.open {
  border-radius: 4px;
}

.custom-select .selected .fa {
  position: absolute;
  content: "";
  top: 14px;
  right: 1em;
  color: #cfcfcf;
}

.custom-select .items {
  margin-top: 5px;
  color: #333;
  border-radius:4px;
  overflow: hidden;
  position: absolute;
  background-color: #fff;
  /* border: 1px solid #008767; */
  left: 0;
  right: 0;
  z-index: 1;
  overflow-y: auto;
  max-height: 160px;
  bottom: 41px;
}

.custom-select .items .optionitem {
  color: #333;
  padding-left: 10px;
  padding-right: 10px;
  position: relative;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  user-select: none;
}
.custom-select .items .optionitem:last-child{
  border-bottom: none;
}
.custom-select .items .optionitem p{
  color:#333
}
.custom-select .items .optionitem:hover p{
  color: #fff;
}
.unavailable {
    pointer-events: none;
}
.selectHide {
  display: none;
}
.on-sale-variant span {
    background: #F63E4D;
    color: #fff;
    padding: 2px 7px;
    border-radius: 10px;
    font-size: 11px;
}
</style>